import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {TaskColor} from 'yougile-model'
import CheckMarkIcon from './check-mark.svg'

const TwIcon = tw(CheckMarkIcon)`
  text-invert
  absolute
  top-1/2
  left-1/2
  transform
  -translate-x-1/2
  -translate-y-1/2
  mt-[.5px]
`

const TwColor = tw.div<{$color: TaskColor}>`
  cursor-pointer
  relative
  w-16
  h-16

  border-1
  border-solid
  ${p => (p.$color ? `border-${p.$color}` : 'border-line-base')}
  ${p => `bg-${p.$color}`}

  rounded-full
  flex
  items-center
  justify-between
`

interface TaskColorItemProps {
  color: TaskColor
  isSelected: boolean
  onClick: (color: TaskColor) => void
}

export const TaskColorItem = observer((props: TaskColorItemProps) => {
  const {color, isSelected, onClick} = props // hue

  const clickHandler = () => {
    onClick(color)
  }

  return (
    <TwColor $color={color} onClick={clickHandler}>
      {isSelected && <TwIcon className="text-primary" />}
    </TwColor>
  )
})
